import { createPartyRequest } from './helper';
export const postPartyNotes = createPartyRequest({
    route: '/party/parties/:partyNo/notes',
    method: 'post',
    source: 'data',
});
